/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from "react";
import { Chart, ChartWrapperOptions } from "react-google-charts";

interface ColumnChartProps {
  data: any[];
  isLoading?: boolean;
  options: ChartWrapperOptions["options"];
}

export const ColumnChart = ({ data, options, isLoading }: ColumnChartProps) => {
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });
  const [chartKey, setChartKey] = useState(0);
  const chartContainerRef = useRef<HTMLDivElement>(null); // Reference to the chart container

  useEffect(() => {
    const chartContainer = chartContainerRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (chartContainer) {
        setChartSize({
          width: chartContainer.offsetWidth,
          height: chartContainer.offsetHeight,
        });
        setChartKey((prevKey) => prevKey + 1); // Update key to force chart re-render
      }
    });

    if (chartContainer) {
      resizeObserver.observe(chartContainer);
    }

    // Clean up the observer when the component unmounts
    return () => {
      if (chartContainer) {
        resizeObserver.unobserve(chartContainer);
      }
    };
  }, []);

  return (
    <div ref={chartContainerRef} className="m-chart">
      {isLoading ? (
        <div className="m-chart__skelton"></div>
      ) : data.length > 1 ? (
        <Chart
          key={chartKey}
          chartType="ColumnChart"
          width={chartSize.width}
          height={chartSize.height}
          data={data}
          options={options}
        />
      ) : (
        <p className="m-chart__nodata">No Data Found</p>
      )}
    </div>
  );
};
